import { Module } from "vuex";
import { State } from "../store";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/plugins/firebase";
import { deserializeDate, serializeDate, SerializedDate } from "@/common/types/SerializedDate";
import { Tower } from "@/common/types/Tower";
import { CalendarRecordData } from "@/common/types/CalendarRecordData";

type CalendarData = { tower: Tower[]; calendar: CalendarRecordData[] };

export type CalendarState = {
  calendar: Record<string, CalendarData>;
};

const calendarModule: Module<CalendarState, State> = {
  namespaced: true,
  state: { calendar: {} },
  mutations: {
    setCalendar(state, { date, data }) {
      state.calendar[date] = data;
    },
    removeCalendar(state) {
      state.calendar = {};
    },
  },
  actions: {
    async getCalendar({ state, commit }, date: Date) {
      const dateString = date.toISOString();

      if (state.calendar[dateString]) {
        return state.calendar[dateString];
      }

      const fn = httpsCallable<unknown, SerializedDate<{ tower: Tower[]; calendar: CalendarRecordData[] }>>(
        functions,
        "calendar-get"
      );
      const result = deserializeDate((await fn(serializeDate({ date: date }))).data);
      commit("setCalendar", { date: dateString, data: result });

      return result;
    },
    removeCalendar({ commit }) {
      commit("removeCalendar");
    },
  },
};

export default calendarModule;
